export default __webpack_public_path__ + "static/media/icon_star.1f72dc21.svg";